import WIDGETS from './widgets';

export default {
  name: 'analytic_ticket_logs',
	spacing: 2,
	widgets: [{ content: WIDGETS.ANALYTIC_TICKET_LOGS, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
